import { Breadcrumb } from 'antd'
import React, { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'

import {
  createRouteItem,
  createTabItem,
  setTitle,
} from '../../utils/breadcrumbHelpers'
import { getRouteHierarchy } from '../../utils/getRouteHierarchy'
import { defaultTabParam, homePath } from '../../utils/paths'
import { BreadcrumbCopyButton } from '../BreadcrumbCopyButton/BreadcrumbCopyButton'

const homeItem = {
  title: (
    <Link className="text-gray-400" to={homePath()}>
      Nástěnka
    </Link>
  ),
  key: 'home',
}

export const AntBreadcrumb: React.FC = () => {
  const location = useLocation()
  const fullPath = location.pathname + location.search
  const searchParams = new URLSearchParams(location.search)
  const currentTab = searchParams.get(defaultTabParam)

  const routeHierarchy = useMemo(
    () => getRouteHierarchy(location.pathname.toLowerCase()),
    [location.pathname]
  )

  const breadcrumbItems = useMemo(() => {
    const lastItem = routeHierarchy[routeHierarchy.length - 1]
    setTitle(lastItem, currentTab)

    const routeItems = routeHierarchy.map((route, index) => {
      const isLastRoute = index === routeHierarchy.length - 1
      return createRouteItem(route, index, isLastRoute, currentTab)
    })

    const tabItem = createTabItem(lastItem, currentTab)

    return [homeItem, ...routeItems, ...tabItem]
  }, [routeHierarchy, currentTab])

  return (
    <div className="flex">
      <Breadcrumb separator="/" items={breadcrumbItems} />
      <BreadcrumbCopyButton copyText={fullPath} />
    </div>
  )
}
